export default `
// STEP 1 - Enter the element ID:
const elementId = '';

function callback(classes) {
    // STEP 2 - Enter custom code here:
    // console.log('classes:', classes);
}



/////// PLEASE DO NOT MODIFY ANY CODE BELOW THIS LINE ///////



const element = document.getElementById(elementId);

if (element) {
    callback(element.className);
}
`;
